import { SET_APP_WINDOW_MODE } from './actionTypes';

const setAppWindowMode = mode => ({ type: SET_APP_WINDOW_MODE, payload: mode });

export default setAppWindowMode;
